<template>
	<div>
		<div class="stats__main">
			<!--<div id="chart"></div>-->
			<ul class="uk-child-width-1-2@s uk-grid-match uk-grid-collapse" uk-grid>
				<li v-if="statData['text']">
					<div>
						<div id="text"></div>
					</div>
				</li>
				<li v-if="statData['attent']">
					<div>
						<div id="attent"></div>
					</div>
				</li>
				<li v-if="statData['table']">
					<div>
						<div id="table"></div>
					</div>
				</li>
				<li v-if="statData['mnemo']">
					<div>
						<div id="mnemo"></div>
					</div>
				</li>
			</ul>
			<ul class="stats__table" v-if="dayArr">
				<StatItem v-for="(item, key) in dayArr" :item="item" :inkey="key" :key="key" />
			</ul>
		</div>
	</div>
</template>

<script>
  import Plotly from "plotly.js-dist";
  import moment from "moment";
  import StatItem from './StatItem'

  export default {
    name: "tab_stats",
    components: {
      StatItem
    },
    data() {
      return {
        dayArr: {}
      }
    },
    props: {
      statData: '',
      selectedTrainer: ''
    },
    watch: {
      'statData': 'makeStatArr'
    },
    computed: {},
    methods: {
      makeStatArr() {
        this.dayArr = {};
        let arr = this.statData;
        let app = this;
        _.forEach(arr, function (i, k) {
          app.makeChartData(i, k);
        });
      },
      makeChartData(arr, type) {
        let examples, errors;
        moment.locale('ru');
        let keys = _.keys(arr);
        let keys2 = _.map(keys, function (i) {
          return moment(i, 'DD-MM-YYYY').format('DD.MM');
        });

        let ex_y = _.map(arr, function (i) {
          return _.reduce(i, function (sum, e) {
            if (type === 'table' || type === 'mnemo') {
              return sum + (e.count ? e.count : 1);
            } else {
              return sum + (e.count ? e.count : 1) - (e.errors ? e.errors : 0);
            }
          }, 0);
        });

        examples = {
          x: keys2,
          y: ex_y,
          name: 'Выполнено',
          type: 'bar',
          с_name: type,
          c_dates: keys,
          marker: { color: '#A9D29B' },
        };

        if (type === 'table') {
          let er_y = _.map(arr, function (i) {
            return _.reduce(i, function (sum, e) {
              return sum + (e.errors ? e.errors : 0);
            }, 0);
          });

          errors = {
            x: keys2,
            y: er_y,
            с_name: type,
            c_dates: keys,
            name: 'Ошибок',
            type: 'bar',
            marker: { color: 'rgb(255, 13, 23)' },
          };

        }
        let data = [examples, (errors ? errors : [])];
        let app = this;
        setTimeout(function () {
          app.makeChart(data, type);
        }, 200);
      },

      makeChart(arr, type) {
        let title;
        switch (type) {
          case 'attent':
            title = 'Внимание';
            break;
          case 'text':
            title = 'Тексты';
            break;
          case 'mnemo':
            title = 'Мнемотехника';
            break;
          case 'table':
            title = 'Таблицы';
            break;
        }

        let app = this;
        let myPlot = document.getElementById(type);
        let layout = {
          barmode: 'stack', title: title,
	        xaxis: {
            type: 'category',
            tickangle: 90,
	        },
	        yaxis: {
            rangemode: 'nonnegative',
	        }
        };
        Plotly.newPlot(myPlot, arr, layout, { displayModeBar: false, locale: 'ru', responsive: true });

        myPlot.on('plotly_click', function (e) {
          let keys = e.points[0].data['c_dates'];
          let point = e.points[0].pointIndex;
          let date = keys[point];
          app.getDayArray(date);

        });
      },
	    getDayArray(date){
		    let full_stat = this.statData;
		    let arr = [];
		    _.forEach(full_stat, function (i) {
			    arr = _.concat(arr, i[date]);
        });
        if (arr.length > 0) {
          this.dayArr = {};
          this.dayArr[date] = arr;
          this.scroll();
        }
	    },
      scroll() {
        setTimeout(function () {
          UIkit.scroll('.headline2', {
            offset: 60
          }).scrollTo('.stats__table');
        }, 100);
      }
    },
    mounted() {
      if (this.statData) this.makeStatArr();
    }
  }
</script>